<template>
  <v-row>

    <v-col cols="12">
      <v-sheet 
        outlined>

        <v-row class="pt-4 pl-4 pr-4">
          <v-col cols="12">
            <v-select
              :items="[{ id: null, name: 'Selecciona la categoría' }, ...type_postulations]"
              v-model="type_postulations_id"
              item-text="name"
              item-value="id"
              label="Tipo de postulación*"
              outlined
            ></v-select>
          </v-col>
        </v-row>
        
        <v-divider></v-divider>

        <v-row class="pa-4" v-if="type_postulations_id==1">

          <v-col cols="12">
            <h2 class="font-weight-light">Datos de la Idea Proyecto</h2>
            <label class="text--secondary">Podés ir completado de forma parcial y guardando con el botón GUARDAR al pie de este formulario </label>
          </v-col>

          <v-col cols="12">

            <v-text-field
              :maxlength="200"
              :counter="200"
              :rules="[v => (v || '' ).length <= 199 || 'El nombre de la idea no debe tener mas de 200 caracteres']"
              ref="title"
              outlined
              v-model="title"
              label="Mi idea*"
              required
            ></v-text-field>
            
            <v-textarea
              :maxlength="300"
              :counter="300"
              :rules="[v => (v || '' ).length <= 299 || 'La descripción no debe tener mas de 300 caracteres']"
              outlined
              ref="description"
              name="description"
              v-model="description"
              label="Breve descripción del proyecto*"
            ></v-textarea>

            <v-select
              :items="[{ id: null, name: 'Selecciona una vertical de trabajo' }, ...vertical_works]"
              v-model="vertical_works_id"
              item-text="name"
              item-value="id"
              label="Vertical de trabajo*"
              outlined
            ></v-select>
            
            <v-text-field
              v-model.number="team_members_count"
              label="Cantidad de integrantes del equipo *"
              type="number"
              min="1"
              step="1"
              outlined
              @keydown="onlyInteger"
              :rules="[
                v => !!v || 'Este campo es obligatorio',
                v => Number.isInteger(v) || 'Debe ser un número entero',
                v => v >= 1 || 'Debe ser mayor o igual a 1'
              ]"
            />

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'El equipo  no debe tener mas de 1500 caracteres']"
              outlined
              ref="team"
              name="team"
              v-model="team"
              label="Equipo emprendedor (integrantes, roles, aportes)*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'Los beneficiarios/clientes/usuarios no debe tener mas de 1500 caracteres']"
              outlined
              ref="beneficiary_clients_users"
              name="beneficiary_clients_users"
              v-model="beneficiary_clients_users"
              label="Beneficiarios/Clientes/Usuarios*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'El problema no debe tener mas de 1500 caracteres']"
              outlined
              ref="problem"
              name="problem"
              v-model="problem"
              label="Problema*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'La solición propuesta no debe tener mas de 1500 caracteres']"
              outlined
              ref="solution"
              name="solution"
              v-model="solution"
              label="Solución*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'La Innovación/Valor agregado no debe tener mas de 1500 caracteres']"
              outlined
              ref="innovation"
              name="innovation"
              v-model="innovation"
              label="Innovación/Valor agregado*"
            ></v-textarea>

            <v-select
              :items="[{ id: null, name: 'Selecciona el grado de desarrollo' }, ...development_degree_ip]"
              v-model="development_degree_ip_id"
              item-text="name"
              item-value="id"
              label="Grado de desarrollo actual de la Idea*"
              outlined
            ></v-select>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'El impacto esperado no debe tener mas de 1500 caracteres']"
              outlined
              ref="expected_impact"
              name="expected_impact"
              v-model="expected_impact"
              label="Impacto esperado*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'El plan de acción no debe tener mas de 1500 caracteres']"
              outlined
              ref="action_plan"
              name="expected_impact"
              v-model="action_plan"
              label="Plan de Acción*"
            ></v-textarea>

            <v-row class="pb-8">
              <v-col cols="12">
                <h2 class="font-weight-light">Antecedentes</h2>
                <label class="text--secondary"> Contanos los avances y logros de la startup agregándolos aquí</label>
              </v-col>

              <v-col cols="12">
                <v-simple-table>
                  <thead>
                    <tr>
                      <th class="text-left" width="20%">
                        Tipo
                      </th>
                      <th class="text-left" width="60%">
                        Name
                      </th>
                      <th class="text-center">
                        Acciones
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in curriculum_idea"
                      :key="index"
                    >
                      <td>{{ item.type }}</td>
                      <td>{{ item.description }}</td>
                      <td class="text-center">
                        <v-btn
                          fab
                          dark
                          x-small
                          color="red"
                          @click="deleteMileston(index)"
                        >
                          <v-icon dark>
                            mdi-trash-can-outline
                          </v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>

              <v-col cols="12" class="text-center">
                <v-btn 
                  outlined
                  @click="add_hito=true"
                  color="primary">
                  <v-icon dark>
                    mdi-plus
                  </v-icon>
                  Agregar antecedente
                </v-btn>
              </v-col>
            </v-row>

          </v-col>

          <v-col cols="12">
            <h2 class="font-weight-light">Datos de radicación:</h2>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12">
            <v-select
              :items="[{ id: null, name: 'Selecciona un pais' }, ...countries]"
              v-model="country_id"
              item-text="name"
              item-value="id"
              label="Pais*"
              outlined
            ></v-select>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" v-if="country_id==argentina_id">
            <v-select
              :items="[{ id: null, name: 'Selecciona una provincia' }, ...provincias]"
              v-model="provincia_id"
              v-on:change="getLocalidades"
              item-text="name"
              item-value="id"
              label="Provincia*"
              outlined
            ></v-select>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" v-if="country_id!=argentina_id">
            <v-text-field
              :maxlength="200"
              :counter="200"
              :rules="[v => (v || '' ).length <= 199 || 'El nombre del estado/provincia no debe tener mas de 200 caracteres']"
              ref="other_provincia"
              outlined
              v-model="other_provincia"
              label="Estado/provincia"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" v-if="country_id==argentina_id">
            <v-select
              :items="[{ id: null, name: 'Selecciona una localidad' }, ...localidades]"
              v-model="localidad_id"
              item-text="name"
              item-value="id"
              label="Localidad*"
              outlined
            ></v-select>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" v-if="country_id!=argentina_id">
            <v-text-field
              :maxlength="200"
              :counter="200"
              :rules="[v => (v || '' ).length <= 199 || 'El nombre de la localidad no debe tener mas de 200 caracteres']"
              ref="other_localidad"
              outlined
              v-model="other_localidad"
              label="Localidad"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-row class="pb-8">

              <v-col cols="12">
                <h2 class="font-weight-light">Imagenes</h2>
                <label class="text--secondary"> 
                  Puedes subir hasta 5 imagenes para ilustrar mejor tu idea
                </label>
              </v-col>

              <template
                v-for="(item, index) in images">
                <v-col
                  v-if="!item.toDelete"
                  cols="3"
                  :key="index">

                  <v-card
                    max-width="380px">
                    <v-img
                      contain
                      :src="item.url_image"
                      class="grey lighten-2"
                      height="220px"
                    >
                    </v-img>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn icon>
                        <v-icon color="black" @click="deleteImage(index)">mdi-delete</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </template>

              <v-col cols="12" class="text-center">
                <v-btn 
                  outlined
                  @click="add_image=true"
                  v-if="images.length<5"
                  color="primary">
                  <v-icon dark>
                    mdi-plus
                  </v-icon>
                  Agregar Imagen
                </v-btn>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <label class="text--secondary text--danger">Los campos señalados con * son obligatorios</label>
          </v-col>
        </v-row>

        <v-row class="pa-4" v-if="type_postulations_id==2">

          <v-col cols="12">
            <h2 class="font-weight-light">Datos de la Idea Proyecto - Escuelas Secundarias</h2>
            <label class="text--secondary">Podés ir completado de forma parcial y guardando con el botón GUARDAR al pie de este formulario </label>
          </v-col>

          <v-col cols="12">

            <v-text-field
              :maxlength="200"
              :counter="200"
              :rules="[v => (v || '' ).length <= 199 || 'El nombre de la idea no debe tener mas de 200 caracteres']"
              ref="title"
              outlined
              v-model="title"
              label="Mi idea*"
              required
            ></v-text-field>
            
            <v-textarea
              :maxlength="300"
              :counter="300"
              :rules="[v => (v || '' ).length <= 299 || 'La descripción no debe tener mas de 300 caracteres']"
              outlined
              ref="description"
              name="description"
              v-model="description"
              label="Breve descripción del proyecto*"
            ></v-textarea>

            <v-select
              :items="[{ id: null, name: 'Selecciona una vertical de trabajo' }, ...vertical_works]"
              v-model="vertical_works_id"
              item-text="name"
              item-value="id"
              label="Vertical de trabajo*"
              outlined
            ></v-select>
            
            <v-text-field
              v-model.number="team_members_count"
              label="Cantidad de integrantes del equipo *"
              type="number"
              min="1"
              step="1"
              outlined
              @keydown="onlyInteger"
              :rules="[
                v => !!v || 'Este campo es obligatorio',
                v => Number.isInteger(v) || 'Debe ser un número entero',
                v => v >= 1 || 'Debe ser mayor o igual a 1'
              ]"
            />

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'El equipo  no debe tener mas de 1500 caracteres']"
              outlined
              ref="team"
              name="team"
              v-model="team"
              label="Equipo emprendedor (integrantes, roles, aportes)*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'Los beneficiarios/clientes/usuarios no debe tener mas de 1500 caracteres']"
              outlined
              ref="beneficiary_clients_users"
              name="beneficiary_clients_users"
              v-model="beneficiary_clients_users"
              label="Beneficiarios/Clientes/Usuarios*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'El problema no debe tener mas de 1500 caracteres']"
              outlined
              ref="problem"
              name="problem"
              v-model="problem"
              label="Problema*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'La solición propuesta no debe tener mas de 1500 caracteres']"
              outlined
              ref="solution"
              name="solution"
              v-model="solution"
              label="Solución*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'La Innovación/Valor agregado no debe tener mas de 1500 caracteres']"
              outlined
              ref="innovation"
              name="innovation"
              v-model="innovation"
              label="Innovación/Valor agregado*"
            ></v-textarea>

            <v-select
              :items="[{ id: null, name: 'Selecciona el grado de desarrollo' }, ...development_degree_ip]"
              v-model="development_degree_ip_id"
              item-text="name"
              item-value="id"
              label="Grado de desarrollo actual de la Idea*"
              outlined
            ></v-select>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'El impacto esperado no debe tener mas de 1500 caracteres']"
              outlined
              ref="expected_impact"
              name="expected_impact"
              v-model="expected_impact"
              label="Impacto esperado*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'El plan de acción no debe tener mas de 1500 caracteres']"
              outlined
              ref="action_plan"
              name="action_plan"
              v-model="action_plan"
              label="Plan de Acción*"
            ></v-textarea>

            <v-row class="pb-8">
              <v-col cols="12">
                <h2 class="font-weight-light">Antecedentes</h2>
                <label class="text--secondary"> Contanos los avances y logros de la startup agregándolos aquí</label>
              </v-col>

              <v-col cols="12">
                <v-simple-table>
                  <thead>
                    <tr>
                      <th class="text-left" width="20%">
                        Tipo
                      </th>
                      <th class="text-left" width="60%">
                        Name
                      </th>
                      <th class="text-center">
                        Acciones
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in curriculum_idea"
                      :key="index"
                    >
                      <td>{{ item.type }}</td>
                      <td>{{ item.description }}</td>
                      <td class="text-center">
                        <v-btn
                          fab
                          dark
                          x-small
                          color="red"
                          @click="deleteMileston(index)"
                        >
                          <v-icon dark>
                            mdi-trash-can-outline
                          </v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>

              <v-col cols="12" class="text-center">
                <v-btn 
                  outlined
                  @click="add_hito=true"
                  color="primary">
                  <v-icon dark>
                    mdi-plus
                  </v-icon>
                  Agregar antecedente
                </v-btn>
              </v-col>
            </v-row>

          </v-col>

          <v-col cols="12">
            <h2 class="font-weight-light">Datos de radicación:</h2>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12">
            <v-select
              :items="[{ id: null, name: 'Selecciona un pais' }, ...countries]"
              v-model="country_id"
              v-on:change="getProvincias"
              item-text="name"
              item-value="id"
              label="Pais*"
              outlined
            ></v-select>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" v-if="country_id==argentina_id">
            <v-select
              :items="[{ id: null, name: 'Selecciona una provincia' }, ...provincias]"
              v-model="provincia_id"
              v-on:change="getLocalidades"
              item-text="name"
              item-value="id"
              label="Provincia*"
              outlined
            ></v-select>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" v-if="country_id!=argentina_id">
            <v-text-field
              :maxlength="200"
              :counter="200"
              :rules="[v => (v || '' ).length <= 199 || 'El nombre del estado/provincia no debe tener mas de 200 caracteres']"
              ref="other_provincia"
              outlined
              v-model="other_provincia"
              label="Estado/provincia"
              required
              :disabled="country_id==null"
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" v-if="country_id==argentina_id">
            <v-select
              :items="[{ id: null, name: 'Selecciona una localidad' }, ...localidades]"
              v-model="localidad_id"
              item-text="name"
              item-value="id"
              label="Localidad*"
              outlined
            ></v-select>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" v-if="country_id!=argentina_id">
            <v-text-field
              :maxlength="200"
              :counter="200"
              :rules="[v => (v || '' ).length <= 199 || 'El nombre de la localidad no debe tener mas de 200 caracteres']"
              ref="other_localidad"
              outlined
              v-model="other_localidad"
              label="Localidad"
              required
              :disabled="country_id==null"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <h2 class="font-weight-light">Datos de la institución educativa:</h2>
            <label class="text--secondary"> 
              Esta información será validada con la institución.
            </label>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              :maxlength="200"
              :counter="200"
              :rules="[v => (v || '' ).length <= 199 || 'El nombre de la escuela no debe tener más de 200 caracteres']"
              ref="title"
              outlined
              v-model="name_school"
              label="Nombre de la institución*"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              :maxlength="200"
              :counter="200"
              :rules="[v => (v || '' ).length <= 199 || 'La dirección no debe tener más de 200 caracteres']"
              ref="title"
              outlined
              v-model="address_school"
              label="Dirección de la institución*"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              :maxlength="200"
              :counter="200"
              :rules="[v => (v || '' ).length <= 199 || 'El teléfono no debe tener más de 200 caracteres']"
              ref="title"
              outlined
              v-model="phone_number_school"
              label="Teléfono de la institución*"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              :maxlength="200"
              :counter="200"
              :rules="[v => (v || '' ).length <= 199 || 'El correo electrónico no debe tener más de 200 caracteres']"
              ref="title"
              outlined
              v-model="email_school"
              label="Correo electrónico de la institución*"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <h2 class="font-weight-light">Datos del docente responsable:</h2>
            <label class="text--secondary"> 
              Esta información será validada con el docente.
            </label>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              :maxlength="200"
              :counter="200"
              :rules="[v => (v || '' ).length <= 199 || 'El nombre no debe tener más de 200 caracteres']"
              ref="title"
              outlined
              v-model="name_teacher"
              label="Nombre del docente*"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              :maxlength="200"
              :counter="200"
              :rules="[v => (v || '' ).length <= 199 || 'El apellido no debe tener más de 200 caracteres']"
              ref="title"
              outlined
              v-model="surname_teacher"
              label="Apellido del docente*"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              :maxlength="50"
              :counter="50"
              :rules="[v => (v || '' ).length <= 199 || 'El DNI/pasaporte/Cedula no debe tener más de 50 caracteres']"
              ref="title"
              outlined
              v-model="dni_teacher"
              label="DNI/pasaporte/Cedula docente*"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12" xs="12">
            <v-text-field
              type="date"
              v-model="birthdate_teacher"
              label="Fecha de nacimiento"
              required
              outlined
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12" xs="12">
            <v-select
              :items="[{ id: null, name: 'Selecciona un genero' }, ...genders]"
              v-model="teacher_gender_id"
              item-text="name"
              item-value="id"
              label="Género del docente*"
              outlined
            ></v-select>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              :maxlength="200"
              :counter="200"
              :rules="[v => (v || '' ).length <= 199 || 'El correo electrónico no debe tener más de 200 caracteres']"
              ref="title"
              outlined
              v-model="email_teacher"
              label="Correo electrónico del docente*"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              :maxlength="200"
              :counter="200"
              :rules="[v => (v || '' ).length <= 199 || 'El teléfono no debe tener más de 200 caracteres']"
              ref="title"
              outlined
              v-model="phone_teacher"
              label="Teléfono del docente*"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-text-field
              :maxlength="200"
              :counter="200"
              :rules="[v => (v || '' ).length <= 199 || 'La materia no debe tener más de 200 caracteres']"
              ref="title"
              outlined
              v-model="subject_teacher"
              label="Materia del docente*"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-row class="pb-8">

              <v-col cols="12">
                <h2 class="font-weight-light">Imagenes</h2>
                <label class="text--secondary"> 
                  Puedes subir hasta 5 imagenes para ilustrar mejor tu idea
                </label>
              </v-col>

              <template
                v-for="(item, index) in images">
                <v-col
                  v-if="!item.toDelete"
                  cols="3"
                  :key="index">

                  <v-card
                    max-width="380px">
                    <v-img
                      contain
                      :src="item.url_image"
                      class="grey lighten-2"
                      height="220px"
                    >
                    </v-img>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn icon>
                        <v-icon color="black" @click="deleteImage(index)">mdi-delete</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </template>

              <v-col cols="12" class="text-center">
                <v-btn 
                  outlined
                  @click="add_image=true"
                  v-if="images.length<5"
                  color="primary">
                  <v-icon dark>
                    mdi-plus
                  </v-icon>
                  Agregar Imagen
                </v-btn>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <label class="text--secondary text--danger">Los campos señalados con * son obligatorios</label>
          </v-col>
        </v-row>

        <v-row class="pa-4" v-if="type_postulations_id==3">
          <v-col cols="12">
            <h2 class="font-weight-light">Datos del Modelo de Negocio</h2>
            <label class="text--secondary">Podés ir completado de forma parcial y guardando con el botón GUARDAR al pie de este formulario </label>
          </v-col>

          <v-col cols="12">
            <v-text-field
              :maxlength="200"
              :counter="200"
              :rules="[v => (v || '' ).length <= 199 || 'El nombre de la idea no debe tener mas de 200 caracteres']"
              ref="title"
              outlined
              v-model="title"
              label="Mi idea*"
              required
            ></v-text-field>
            
            <v-textarea
              :maxlength="300"
              :counter="300"
              :rules="[v => (v || '' ).length <= 299 || 'La breve descripción del proyecto no debe tener mas de 200 caracteres']"
              outlined
              ref="description"
              name="description"
              v-model="description"
              label="Breve descripción del proyecto*"
            ></v-textarea>

            <v-select
              :items="[{ id: null, name: 'Selecciona una vertical de trabajo' }, ...vertical_works]"
              v-model="vertical_works_id"
              item-text="name"
              item-value="id"
              label="Vertical de trabajo*"
              outlined
            ></v-select>
            
            <v-text-field
              v-model.number="team_members_count"
              label="Cantidad de integrantes del equipo *"
              type="number"
              min="1"
              step="1"
              outlined
              @keydown="onlyInteger"
              :rules="[
                v => !!v || 'Este campo es obligatorio',
                v => Number.isInteger(v) || 'Debe ser un número entero',
                v => v >= 1 || 'Debe ser mayor o igual a 1'
              ]"
            />

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'El equipo emprendedor no debe tener mas de 1500 caracteres']"
              outlined
              ref="team"
              name="team"
              v-model="team"
              label="Equipo emprendedor (integrantes, roles, aportes)*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'El problema detectado no debe tener mas de 1500 caracteres']"
              outlined
              ref="problem"
              name="problem"
              v-model="problem"
              label="Problema*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'La solición propuesta no debe tener mas de 1500 caracteres']"
              outlined
              ref="solution"
              name="solution"
              v-model="solution"
              label="Solución*"
            ></v-textarea>

            <v-textarea
              :maxlength="2000"
              :counter="2000"
              :rules="[v => (v || '' ).length <= 1999 || 'El mercado no debe tener mas de 2000 caracteres']"
              outlined
              ref="market"
              name="market"
              v-model="market"
              label="Mercado y segmentos de clientes*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'El servicio o producto que ofrece no debe tener mas de 1500 caracteres']"
              outlined
              ref="value_proposal"
              name="value_proposal"
              v-model="value_proposal"
              label="Propuesta de Valor*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'Los canales y relación con clientes no debe tener mas de 1500 caracteres']"
              outlined
              ref="channels_with_customers"
              name="channels_with_customers"
              v-model="channels_with_customers"
              label="Canales y relación con clientes*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'El modelo de ingresos no debe tener mas de 1500 caracteres']"
              outlined
              ref="revenue_model"
              name="revenue_model"
              v-model="revenue_model"
              label="Modelo de ingresos*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'Las actividades y recursos claves no debe tener mas de 1500 caracteres']"
              outlined
              ref="activities_resources"
              name="activities_resources"
              v-model="activities_resources"
              label="Actividades y recursos claves*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'La inversión y estructura de costos no debe tener mas de 1500 caracteres']"
              outlined
              ref="investment_cost"
              name="investment_cost"
              v-model="investment_cost"
              label="Inversión y Estructura de costos*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'La competencia y soluciones alternativas existentes no debe tener mas de 1500 caracteres']"
              outlined
              ref="competence"
              name="competence"
              v-model="competence"
              label="Competencia y soluciones alternativas existentes*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'el impacto esparado no debe tener mas de 1500 caracteres']"
              outlined
              ref="expected_impact"
              name="expected_impact"
              v-model="expected_impact"
              label="Impacto esparado*"
            ></v-textarea>

            <v-row>
              <v-col cols="12" xl="6" md="6" sm="12">
                <v-select
                  :items="[{ id: null, name: 'Selecciona el grado de desarrollo actual' }, ...development_degree_mdn]"
                  v-model="development_degree_mdn_id"
                  item-text="name"
                  item-value="id"
                  label="Grado de desarrollo actual*"
                  outlined
                ></v-select>
              </v-col>

              <v-col cols="12" xl="6" md="6" sm="12">
                <v-select
                  :items="[{ id: null, name: 'Selecciona el estadio actual' }, ...entrepreneurship_stadium]"
                  v-model="entrepreneurship_stadia_id"
                  item-text="name"
                  item-value="id"
                  label="¿Como se encuentra el proyecto?*"
                  outlined
                  :disabled="development_degree_mdn_id==null"
                ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <h2 class="font-weight-light">Antecedentes</h2>
                <label class="text--secondary"> Contanos los avances y logros de la startup agregándolos aquí</label>
              </v-col>

              <v-col cols="12">
                <v-simple-table>
                  <thead>
                    <tr>
                      <th class="text-left" width="20%">
                        Tipo
                      </th>
                      <th class="text-left" width="60%">
                        Name
                      </th>
                      <th class="text-center">
                        Acciones
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in curriculum_idea"
                      :key="index"
                    >
                      <td>{{ item.type }}</td>
                      <td>{{ item.description }}</td>
                      <td class="text-center">
                        <v-btn
                          fab
                          dark
                          x-small
                          color="red"
                          @click="deleteMileston(index)"
                        >
                          <v-icon dark>
                            mdi-trash-can-outline
                          </v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>

              <v-col cols="12" class="text-center">
                <v-btn 
                  outlined
                  @click="add_hito=true"
                  color="primary">
                  <v-icon dark>
                    mdi-plus
                  </v-icon>
                  Agregar
                </v-btn>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <h2 class="font-weight-light">Datos de radicación:</h2>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12">
            <v-select
              :items="[{ id: null, name: 'Selecciona un pais' }, ...countries]"
              v-model="country_id"
              item-text="name"
              item-value="id"
              label="Pais*"
              outlined
            ></v-select>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" v-if="country_id==argentina_id">
            <v-select
              :items="[{ id: null, name: 'Selecciona una provincia' }, ...provincias]"
              v-model="provincia_id"
              v-on:change="getLocalidades"
              item-text="name"
              item-value="id"
              label="Provincia*"
              outlined
            ></v-select>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" v-if="country_id!=argentina_id">
            <v-text-field
              :maxlength="200"
              :counter="200"
              :rules="[v => (v || '' ).length <= 199 || 'El nombre del estado/provincia no debe tener mas de 200 caracteres']"
              ref="other_provincia"
              outlined
              v-model="other_provincia"
              label="Estado/provincia"
              required
              :disabled="country_id==null"
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" v-if="country_id==argentina_id">
            <v-select
              :items="[{ id: null, name: 'Selecciona una localidad' }, ...localidades]"
              v-model="localidad_id"
              item-text="name"
              item-value="id"
              label="Localidad*"
              outlined
            ></v-select>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" v-if="country_id!=argentina_id">
            <v-text-field
              :maxlength="200"
              :counter="200"
              :rules="[v => (v || '' ).length <= 199 || 'El nombre de la localidad no debe tener mas de 200 caracteres']"
              ref="other_localidad"
              outlined
              v-model="other_localidad"
              label="Localidad"
              required
              :disabled="country_id==null"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-row class="pb-8">

              <v-col cols="12">
                <h2 class="font-weight-light">Imagenes</h2>
                <label class="text--secondary"> 
                  Puedes subir hasta 5 imagenes para ilustrar mejor tu idea
                </label>
              </v-col>

              <template
                v-for="(item, index) in images">
                <v-col
                  v-if="!item.toDelete"
                  cols="3"
                  :key="index">

                  <v-card
                    max-width="380px">
                    <v-img
                      contain
                      :src="item.url_image"
                      class="grey lighten-2"
                      height="220px"
                    >
                    </v-img>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn icon>
                        <v-icon color="black" @click="deleteImage(index)">mdi-delete</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </template>

              <v-col cols="12" class="text-center">
                <v-btn 
                  outlined
                  @click="add_image=true"
                  v-if="images.length<5"
                  color="primary">
                  <v-icon dark>
                    mdi-plus
                  </v-icon>
                  Agregar Imagen
                </v-btn>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <label class="text--secondary text--danger">Los campos señalados con * son obligatorios</label>
          </v-col>

        </v-row>
        
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-8 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :disabled="btn_loading"
        :to="{ name: 'convocation'}">
        <v-icon left>
          mdi-arrow-left
        </v-icon>
          Volver
      </v-btn>
      <v-spacer />

      <v-btn
        depressed
        :loading="btn_loading"
        color="primary"
        v-if="id"
        @click="updateMyIdea"
        >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Guardar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="add_hito"
      persistent
      max-width="700px"
      >
      <v-card>
        <v-card-title>
          <span class="text-h5">Antecedentes:</span>
        </v-card-title>
        <v-card-text>

            <v-row>
              <v-col
                cols="12"
                class="pt-9"
              >
                <v-select
                  v-model="milestone_type"
                  :items="['Hitos', 'Participación en eventos', 'Convocatorias', 'Participación en otros espacios UNL [Expresiva, Idear, PTLC, Emprendedores, Otros]', 'Financiamiento']"
                  label="Tipo"
                  required
                  outlined
                ></v-select>
              </v-col>

              <v-col
                cols="12"
              >
                <v-textarea
                  v-model="milestone_description"
                  label="Decripción"
                  outlined
                  required
                  :counter="300"
                  :maxlength="300"
                ></v-textarea>
              </v-col>
 
            </v-row>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="add_hito = false"
          >
            Cerrar
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addMilestone"
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="add_image"
      persistent
      max-width="700px"
      >
      <v-card>
        <v-card-title>
          <span class="text-h5">Imagen:</span>
        </v-card-title>
        <v-card-text>

            <v-row>
              <v-col
                cols="12"
                class="pt-9"
              >
                <v-file-input
                  outlined
                  v-model="image"
                  accept="image/png, image/jpeg, image/bmp"
                  prepend-icon="mdi-file"
                  label="Imagen"
                  :messages="['Solo archivos PNG o JPG, de tamaño inferior a los 10MB']"
                  :rules="[rules.size]"
                ></v-file-input>
              </v-col>
            </v-row>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="add_image = false"
          >
            Cerrar
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addImage()"
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_error"
      width="500">
      <v-card>
        <v-card-title class="text-h5 lighten-2">
          Atención
        </v-card-title>

        <v-card-text
          class="pt-4 pb-6"
          style="white-space: pre-line"
        >
          {{ error_message }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog_error = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="error_image"
      :timeout="3000"
      color="red accent-2"
    >
      {{ snackbarMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="error_image = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>

  </v-row>
</template>
<script>
  const APP_URL = process.env.VUE_APP_URL
  import axios from 'axios'
  import { mapGetters } from 'vuex'

  export default {
    name: 'myIdea',

    data: () => ({
      loading:true,
      btn_loading:false,
      aux:null, 
      show: false,
      error_image: false,
      snackbarMessage: '',

      convocation:[],

      id: null,
      title:null,
      description:null,

      vertical_works_id: null,
      vertical_works:[],

      team:null,
      team_members_count:1,
      beneficiary_clients_users:null,
      problem:null,
      solution:null,
      innovation:null,
      market:null,
      value_proposal:null,
      channels_with_customers:null,
      revenue_model:null,
      activities_resources:null,
      investment_cost:null,
      competence:null,
      expected_impact:null,
      action_plan:null,

      development_degrees_id: null,
      development_degree:[],

      development_degree_ip_id: null,
      development_degree_ip:[],

      development_degree_mdn_id:null,
      development_degree_mdn: [],
      
      entrepreneurship_stadia_id: null,
      entrepreneurship_stadium:[],

      entrepreneurship_needs_2:[],
      entrepreneurship_needs:[],
      needs:[],

      milestone_id: 100,
      milestone_type:'Hitos',
      milestone_description: '',

      images_delete: [],
      images: [],
      image: null,
      url_image: null,

      rules: {
        size: value => {
          return !value || value.size <= 10 * 1024 * 1024 || 'El tamaño del archivo debe ser menor a 10 MB';
        }
      },

      headers: [
        { text: 'Tipo', value: 'type', width: '20%'},
        { text: 'Descripción', value: 'description', width: '50%' },
        { text: 'acciones', value: 'action' },
      ],
      curriculum_idea: [],

      country_id:null,
      argentina_id:null,
      countries:[],

      provincia_id: null,
      provincias:[],

      localidad_id: null,
      localidades:[],

      other_provincia:null,
      other_localidad:null,

      name_school: null,
      address_school: null,
      phone_number_school: null,
      email_school: null,

      name_teacher: null,
      surname_teacher: null,
      dni_teacher: null,
      phone_teacher: null,
      email_teacher: null,
      subject_teacher: null,
      birthdate_teacher: null,

      teacher_gender_id: null,
      genders:[],

      type_postulations_id: null,
      type_postulations:[],

      editions:null,

      add_hito:false,
      add_image: false,

      errors: [],
      dialog_error: false,
      error_message: null
    }),
    computed: {
      ...mapGetters([ 
          'convocation_form'
      ])
    },
    methods:{
      onlyInteger(e) {
        const allowedKeys = [
          'Backspace',
          'Delete',
          'Tab',
          'ArrowLeft',
          'ArrowRight'
        ];

        if (allowedKeys.includes(e.key)) {
          return;
        }

        if (!/^\d$/.test(e.key)) {
          e.preventDefault();
        }
      },

      async getEntrepreneurshipStadium(){
        try {
          await axios.get('entrepreneurship-stadium').then(response =>{
            this.entrepreneurship_stadium = response.data.entrepreneurship_stadium
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },	

      async getDevelopmentDegreeIP(){
        try {
          await axios.get('development-degree-ip').then(response =>{
            this.development_degree_ip = response.data.development_degree
            if(this.development_degree.length>1 && this.development_degree_ip_id==null){
              this.development_degree_ip_id = this.development_degree_ip[0].id
            }
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },

      async getDevelopmentDegreeMDN(){
        try {
          await axios.get('development-degree-mdn').then(response =>{
            this.development_degree_mdn = response.data.development_degree
            if(this.development_degree_mdn.length>1 && !this.development_degree_mdn_id){
              this.development_degree_mdn_id = this.development_degree_mdn[0].id
            }
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },

      async getVerticalWorks(){
        try {
          await axios.get('vertical-works').then(response =>{
            this.vertical_works = response.data.vertical_works
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },	

      async getEntrepreneurshipNeeds(){
        try {
          await axios.get('entrepreneurship-needs').then(response =>{
            this.needs = response.data.entrepreneurship_needs
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },	

      async getCountries(){
        try {
          await axios.get('countries').then(response =>{
            this.countries = response.data.data.countries

            this.countries.forEach(element=>{
              if(element.name=='Argentina'){
                this.argentina_id=element.id
              }
            })
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },

      async getProvincias(){
        try {
          await axios.get('provincias').then(response =>{
            this.provincias = response.data.provincias
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },

      async getLocalidades(){
        try {
          await axios.get('provincias-localidades/'+this.provincia_id).then(response =>{
            this.localidades = response.data.provincia.localidads
            this.localidad_id = null
          }).catch(error => {
            console.log(error);
          })
          
        } catch (error) {
          console.log(error)
        }
      },

      async getLocalidadesCreated(){
        try {
          await axios.get('provincias-localidades/'+this.provincia_id).then(response =>{
            this.localidades = response.data.provincia.localidads
          }).catch(error => {
            console.log(error);
          })
          
        } catch (error) {
          console.log(error)
        }
      },

      async getTypePostulations(){
        try {
          await axios.get('type-postulations').then(response =>{
            this.type_postulations = response.data.data.type_postulations
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },

      async getGenders(){
        try {
          await axios.get('genders').then(response =>{
            if(response.data.length!==0){
              this.genders = response.data.genders
            }
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },

      addMilestone(){
        let data = {  
                      'id': this.milestone_id,
                      'type':this.milestone_type, 
                      'description': this.milestone_description, 
                      'action':null 
                    };
        
        this.curriculum_idea.push(data)
        this.milestone_type = 'Hitos'
        this.milestone_description = ''
        this.add_hito = false
      },

      deleteMileston(index){
        this.curriculum_idea.splice(index, 1)
      },

      addImage() {
        const maxSize = 10 * 1024 * 1024;

        if (this.image.size > maxSize) {
          this.snackbarMessage = 'La imagen no puede superar los 10 MB';
          this.error_image = true;
          return;
        }

        if (!this.image) {
          this.snackbarMessage = 'Debe seleccionar una imagen';
          this.snackbar = true;
          return;
        }

        const data = {
          image: this.image,
          url_image: URL.createObjectURL(this.image),
          toDelete: false
        };

        this.images.push(data);

        this.image = null;
        this.url_image = null;
        this.add_image = false;
      },

      async getMyIdea(){
        await axios.get('convocation/'+this.convocation_form.convocation_form.id).then(response =>{
          if(response.data.length!==0){
            this.aux = response.data
            this.convocation = response.data.convocation
            this.id = response.data.convocation.id
            this.type_postulations_id = response.data.convocation.type_postulations_id
            this.title = response.data.convocation.title
            this.description = response.data.convocation.description
            
            this.team = response.data.convocation.team
            this.team_members_count = response.data.convocation.team_members_count
            this.beneficiary_clients_users = response.data.convocation.beneficiary_clients_users
            this.problem = response.data.convocation.problem
            this.solution = response.data.convocation.solution
            this.innovation = response.data.convocation.innovation

            this.development_degrees_id = response.data.convocation.development_degrees_id

            this.market = response.data.convocation.market
            this.value_proposal = response.data.convocation.value_proposal

            this.channels_with_customers = response.data.convocation.channels_with_customers
            this.revenue_model = response.data.convocation.revenue_model
            this.activities_resources = response.data.convocation.activities_resources
            this.investment_cost = response.data.convocation.investment_cost
            this.competence = response.data.convocation.competence
            this.expected_impact = response.data.convocation.expected_impact
            this.action_plan = response.data.convocation.action_plan

            this.curriculum_idea = response.data.convocation.curriculum_idea

            this.vertical_works_id = response.data.convocation.vertical_works_id

            this.development_degree_ip_id = response.data.convocation.development_degree_ip_id
            this.development_degree_mdn_id = response.data.convocation.development_degree_mdn_id

            this.entrepreneurship_stadia_id = response.data.convocation.entrepreneurship_stadia_id

            this.name_school = response.data.convocation.name_school
            this.address_school = response.data.convocation.address_school
            this.phone_number_school = response.data.convocation.phone_number_school
            this.email_school = response.data.convocation.email_school

            this.name_teacher = response.data.convocation.name_teacher
            this.surname_teacher = response.data.convocation.surname_teacher
            this.dni_teacher = response.data.convocation.dni_teacher
            this.birthdate_teacher = response.data.convocation.birthdate_teacher
            this.phone_teacher = response.data.convocation.phone_teacher
            this.email_teacher = response.data.convocation.email_teacher
            this.subject_teacher = response.data.convocation.subject_teacher
            this.teacher_gender_id = response.data.convocation.teacher_gender_id

            this.country_id = response.data.convocation.country_id
            this.provincia_id = response.data.convocation.provincia_id
            this.localidad_id = response.data.convocation.localidad_id

            this.other_provincia = response.data.convocation.other_provincia
            this.other_localidad = response.data.convocation.other_localidad

            this.images = response.data.convocation.images.map(e => ({
              image: null,
              image_path: e.image_path,
              url_image: `${APP_URL}${e.image_path}`,
              toDelete: false 
            }))
          }
          this.loading = false
        }).catch(error => {
          console.log(error);
        })
      },

      async updateMyIdea(){
        this.btn_loading = true;
        const formData = new FormData();

        const fields = {
          type_postulations_id: this.type_postulations_id,
          title: this.title,
          description: this.description,
          vertical_works_id: this.vertical_works_id,
          team: this.team,
          team_members_count: this.team_members_count,
          beneficiary_clients_users: this.beneficiary_clients_users,
          problem: this.problem,
          solution: this.solution,
          innovation: this.innovation,
          development_degrees_id: this.development_degrees_id,
          action_plan: this.action_plan,
          market: this.market,
          value_proposal: this.value_proposal,
          channels_with_customers: this.channels_with_customers,
          revenue_model: this.revenue_model,
          activities_resources: this.activities_resources,
          investment_cost: this.investment_cost,
          competence: this.competence,
          expected_impact: this.expected_impact,
          development_degree_ip_id: this.development_degree_ip_id,
          development_degree_mdn_id: this.development_degree_mdn_id,
          entrepreneurship_stadia_id: this.entrepreneurship_stadia_id,
          country_id: this.country_id,
          provincia_id: this.provincia_id,
          localidad_id: this.localidad_id,
          other_provincia: this.other_provincia,
          other_localidad: this.other_localidad,
          name_school: this.name_school,
          address_school: this.address_school,
          phone_number_school: this.phone_number_school,
          email_school: this.email_school,
          name_teacher: this.name_teacher,
          surname_teacher: this.surname_teacher,
          dni_teacher: this.dni_teacher,
          birthdate_teacher: this.birthdate_teacher,
          phone_teacher: this.phone_teacher,
          email_teacher: this.email_teacher,
          subject_teacher: this.subject_teacher,
          teacher_gender_id: this.teacher_gender_id,
          curriculum_idea: JSON.stringify(this.curriculum_idea),
          images_delete: JSON.stringify(this.images_delete)
        };

        for (const key in fields) {
          this.appendIfNotNull(formData, key, fields[key]);
        }

        this.images.forEach((item, index) => {
          this.appendIfNotNull(formData, `images[${index}]`, item.image);
          this.appendIfNotNull(formData, `urls[${index}]`, item.url_image);
        });

        try {
          const response = await axios.post(`convocation/${this.convocation_form.convocation_form.id}`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });

          console.log('Response:', response.data);
          this.btn_loading = false;
          this.$router.push({ name: 'convocation' });
        } catch (error) {
          this.error_message = error.response.data.errors.error[0]
          this.dialog_error = true;
          this.btn_loading = false;
        }
      },

      appendIfNotNull(formData, key, value) {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      }
    },
    async created() {
      try {
        await Promise.all([
          this.getTypePostulations(),
          this.getCountries(),
          this.getProvincias(),
          this.getLocalidades(),
          this.getEntrepreneurshipStadium(),
          this.getDevelopmentDegreeIP(),
          this.getDevelopmentDegreeMDN(),
          this.getVerticalWorks(),
          this.getGenders()
        ]);
        await this.getMyIdea();
        this.getLocalidadesCreated();
      } catch (error) {
        console.log(error);
      }
    }
  }
</script>